import { IDeleteFuncionarioAprovadorUseCase } from "../../../presentation/useCases/delete/delete_funcionario_aprovador_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * DeleteFuncionarioAprovadorUseCase
 */

export class DeleteFuncionarioAprovadorUseCase implements IDeleteFuncionarioAprovadorUseCase {
  constructor(private readonly repository: IComprasRepository) {}

  async deleteFuncionarioAprovador(idFuncionarioAprovador: number): Promise<void> {
    await this.repository.deleteFuncionarioAprovador(idFuncionarioAprovador);
  }
}
